import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ExcursionsDetails } from './details';
import { ExcursionsList } from './list';
import { ExcursionsStatus } from './status';
import { MtsWidgetDisplay } from '../../components/mts-widget-display';

// prettier-ignore
const ExcursionsBooking = React.lazy(() => import('./booking' /* webpackChunkName: "booking" */));

const ExcursionsContext = React.createContext();

export function useExcursionsContext() {
  return React.useContext(ExcursionsContext);
}

export function Excursions() {
  const state = useState();

  return (
    <ExcursionsContext.Provider value={{ state }}>
      <Routes>
        <Route path={':code'} element={<ExcursionsDetails />} />
        <Route path={':code/buchen'} element={<ExcursionsBooking />} />
        <Route path={'buchung'} element={<ExcursionsStatus />} />
        <Route path={'mts'} element={<MtsWidgetDisplay />} />

        <Route path="*" element={<ExcursionsList />} />
      </Routes>
    </ExcursionsContext.Provider>
  );
}

export default Excursions;
